module.exports = __webpack_public_path__ + "static/cogito-logo-a1b57643c67d0e2d4e46687699ebc8be.png";